import { Grid, Box, styled } from '@mui/material';

export const SummaryPropertyWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));

export const SummaryPropertyValueWrapper = styled(Box)(() => ({
  flexGrow: 1
}));
